import dateLookupFormatter from "../formatters/dateLookupFormatter";

export default {
  queries: {
    dateLookupAnticipation: {
      fields: ['createdAt'],
      resultFormatter: dateLookupFormatter
    }
  }
}
